module.exports = __webpack_public_path__ + "img/shebao.07a0dc7d.png";